import { useEffect } from 'react';
import styles from './SuccessModal.module.css';

function SuccessModal({ isOpen, onClose, onViewProfile, title, message, buttonText = 'Voir mon profil' }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {/* Confetti decoration */}
        <div className={styles.confetti}>
          <div className={styles.confettiPiece} style={{ left: '10%', top: '10%', background: '#FFB84D' }} />
          <div className={styles.confettiPiece} style={{ left: '20%', top: '5%', background: '#4D7CFF' }} />
          <div className={styles.confettiPiece} style={{ left: '80%', top: '15%', background: '#FF6B9D' }} />
          <div className={styles.confettiPiece} style={{ left: '85%', top: '8%', background: '#FFD54D' }} />
          <div className={styles.confettiPiece} style={{ left: '15%', top: '20%', background: '#5DDAB4' }} />
          <div className={styles.confettiPiece} style={{ left: '75%', top: '25%', background: '#4D7CFF' }} />
          <div className={styles.confettiPiece} style={{ left: '5%', top: '30%', background: '#FF6B9D' }} />
          <div className={styles.confettiPiece} style={{ left: '90%', top: '35%', background: '#5DDAB4' }} />
          <div className={styles.confettiPiece} style={{ left: '25%', top: '40%', background: '#FFB84D' }} />
          <div className={styles.confettiPiece} style={{ left: '70%', top: '45%', background: '#FFD54D' }} />
        </div>

        {/* Success icon */}
        <div className={styles.iconWrapper}>
          <div className={styles.iconCircle}>
            <svg className={styles.checkIcon} viewBox="0 0 52 52">
              <circle className={styles.checkCircle} cx="26" cy="26" r="25" fill="none"/>
              <path className={styles.checkPath} fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
          </div>
        </div>

        {/* Content */}
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.message}>{message}</p>

        {/* CTA Button */}
        <button
          type="button"
          className={styles.ctaButton}
          onClick={onViewProfile}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}

export default SuccessModal;

